
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/[id]",
      function () {
        return require("private-next-pages/apps/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/[id]"])
      });
    }
  